import axiosClient from './axiosClient';

export const getListQuoteByClient = (dataParam?: any) => {
    const url = `${process.env.REACT_APP_PUBLIC_URL}/quotes/api/quotes/client${dataParam}`;
    return axiosClient.get(url);
};
